import { createTranslations } from '@npco/common-utils-translations'

export const completeStageTranslations = createTranslations({
  secondaryButtonLabel: 'New Transfer',
  primaryButtonLabel: 'Close',
})
